import { useMutation } from "react-query";
import { logFeatureAction, ActionLogCreateInput } from "api/feedback";

/**
 * Hook for logging feature actions
 * 
 * Sends action logs to the backend to track AI feature usage patterns.
 * 
 * @returns {Object} Mutation object with logAction function
 * 
 * @example
 * const { logAction } = useLogFeatureAction();
 * 
 * const handleAction = () => {
 *   logAction({
 *     actionTaken: "copy_edited",
 *     entityType: "claim",
 *     entityId: 123,
 *     generatedCopy: "Original text",
 *     submittedCopy: "Edited text"
 *   });
 * };
 */
export const useLogFeatureAction = () => {
  const { mutate: logAction, ...rest } = useMutation(
    (actionData: ActionLogCreateInput) => logFeatureAction(actionData),
    {
      onError: (error: Error) => {
        console.error("Error logging feature action:", error);
      },
    }
  );

  return {
    logAction,
    ...rest,
  };
};